module.exports = __webpack_public_path__ + "static/media/house-on-beach.bfb67668.jpeg";